import { RadioGroupOption as t } from "@headlessui/vue";
import { defineComponent as r, toRef as o } from "vue";
import { useThemeColorOrInject as s } from "../../composables/theme.mjs";
const a = {
  gray: {
    checkedButtonClasses: "bg-white dark:bg-zinc-900 shadow-sm ring-1 ring-black/5",
    iconClasses: "text-zinc-500 dark:text-zinc-200 group-hover:text-zinc-800 dark:group-hover:text-white",
    checkedIconClasses: "text-primary-500",
    labelClasses: "text-zinc-600 group-hover:text-zinc-800 dark:text-zinc-200 dark:group-hover:text-white",
    checkedLabelClasses: "text-zinc-900 dark:text-white"
  },
  white: {
    checkedButtonClasses: "bg-primary-600",
    iconClasses: "text-zinc-500 group-hover:text-zinc-700 dark:text-zinc-300 dark:group-hover:text-white",
    checkedIconClasses: "text-white",
    labelClasses: "text-zinc-600 group-hover:text-zinc-800 dark:text-zinc-300 dark:group-hover:text-white",
    checkedLabelClasses: "text-white"
  },
  primary: {
    checkedButtonClasses: "bg-white dark:bg-zinc-850 shadow-sm dark:shadow-none",
    iconClasses: "text-zinc-100 group-hover:text-white",
    checkedIconClasses: "text-primary-600 dark:text-primary-500",
    labelClasses: "text-zinc-100 group-hover:text-white",
    checkedLabelClasses: "text-primary-600 dark:text-primary-500"
  }
}, l = r({
  name: "TuiSwitchButton",
  components: {
    RadioGroupOption: t
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    on: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    return { themeColor: s(o(() => e.on)) };
  },
  computed: {
    spec() {
      return a[this.themeColor];
    }
  }
});
export {
  l as default
};
//# sourceMappingURL=SwitchButton.vue2.mjs.map
